<template>
  <div v-if="user">
    <div class="inner-texts-b-1">
      <h1>Current filter</h1>
    </div>
    <app-progress :totalDays="totalDays" :remainingDays="remainingDays" />
    <div class="rst-btn">
      <button
        v-confirm="{
          ok: resetJug,
          okText: 'Yes',
          cancelText: 'No',
          animation: 'fade',
          message: 'Are you sure you want to reset your indicator',
        }"
      >Reset</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import AppProgress from '@/components/prgress.vue'
export default {
  head: function() {
    return {
      title: {
        inner: 'Indicator'
      }
    }
  },
  data() {
    return {
      html: `
          <div class="modal-dialog" role="document">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="reset-texts">
                        <p>Are you sure you want br to reset your indicator</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn">Yes</button>
                    <button class="btn" data-dismiss="modal">NO</button>
                </div>
            </div>
        </div>
            `
    }
  },
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle']),
    totalDays () {
      return this.user.filter.type === 'v1' ? 60 : 45;
    },
    remainingDays () {
      return this.totalDays - parseInt((Date.now() - this.user.filter.replacedAt) / (1000 * 60 * 60 * 24), 10);
    },
  },
  watch: {
    user (user){
      if (!(user && user.filter && user.filter.type)) {
        // this.$nextTick('')
        this.$router.replace('/select-jug')
      }
    }
  },
  components: {
    AppProgress
  },
  methods: {
    ...mapActions('authentication', ['resetJug'])
  }
}
</script>